module.exports = __webpack_public_path__ + "img/wx.6f0176c1.jpg";